import React from 'react';
import { Icons } from '../../Icons/Icons';

interface ActionMenuTriggerProps {
  triggerRef: React.RefObject<HTMLButtonElement>;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ActionMenuTrigger: React.FC<ActionMenuTriggerProps> = ({ triggerRef, onClick }) => {
  return (
    <button ref={triggerRef} className="menu-trigger" onClick={onClick}>
      {Icons.Dots}
    </button>
  );
};
